import { legacyLaunchPageQueryParamsSchema } from "@/pages/launch/schemata";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/",
)({
  validateSearch: legacyLaunchPageQueryParamsSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/apps/$appId/launch",
      params: {
        appId: params.appId,
      },
      search,
    });
  },
});
